import React, {useEffect, useContext} from 'react'
import {Button} from 'antd'
import {Arguments} from "../common/Arguments";
import {sideMenuContext} from "../../../router/IndexRouter";
import {GetApiMethod} from "../common/ApiMethod";
import TableComponent from "../common/TablePaginationComponent";
import {ExportToExcel} from "../common/ExportDataToExcelComponent";
import {DateRangePicker} from "../common/SelectDateRange";
import {camelObj} from "../common/ConversionMethod";

export default function OtherActivitiesAdmin() {
    const {dataSource, setDataSource, setCopyDataSource, setCurrentItem, copyDataSource} = useContext(sideMenuContext);
    const getApi = Arguments.host + "/society_organization/home/api!organizationOtherActivity.do";

    useEffect(() => {
        setDataSource([]);
        GetApiMethod({getApi, setDataSource, setCopyDataSource});
    }, [getApi])

    const detailClick = (item) => {
        // 将数据改成驼峰形式保存在 currentItem 中，方便详情页审核提交用
        setCurrentItem(camelObj(item));
        window.open(Arguments.reactUrl + "/society/other-activity-admin/detail", "_self");
    }

    const columns = [
        {
            title: '序号',
            dataIndex: 'showIndex',
            width: 90,
            sorter: (a, b) => a.showIndex - b.showIndex,
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '社会组织',
            dataIndex: 'organization_name',
            width: 200
        },
        {
            title: '活动名称',
            dataIndex: 'activity_name',
            width: 200
        },
        {
            title: '活动主题',
            responsive: ['lg'],
            dataIndex: 'activity_subject',
            width: 200
        },
        {
            title: "活动时间",
            dataIndex: 'activity_date',
            width: 120
        },
        {
            title: "活动规模",
            responsive: ['lg'],
            dataIndex: 'activity_scope',
            width: 100
        },
        {
            title: "活动地址",
            dataIndex: 'activity_address',
            width: 200
        },
        {
            title: "发言嘉宾",
            dataIndex: 'activity_expert',
            width: 200
        },
        {
            title: "审核状态",
            dataIndex: 'check_status',
            width: 100
        },
        {
            title: "操作",
            width: 120,
            render: (item) => (
                <Button type="link" onClick={() => detailClick(item)}>查看详情</Button>
            )
        }
    ];

    const newData = dataSource.map(
        (
            {
                organization_name,
                activity_name,
                activity_subject,
                activity_date,
                activity_address,
                activity_scope,
                activity_expert,
                check_status,
                activity_memo
            }
        ) => (
            {
                "社会组织": organization_name,
                "活动名称": activity_name,
                "活动主题": activity_subject,
                "活动时间": activity_date,
                "活动地点": activity_address,
                "活动规模": activity_scope,
                "发言嘉宾": activity_expert,
                "审核状态": check_status,
                "备注": activity_memo
            }
        )
    )

    const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}))

    return (
        <>
            <ExportToExcel tableData={newData}/>
            <DateRangePicker dataSource={dataSource} setDataSource={setDataSource} copyDataSource={copyDataSource}/>
            <TableComponent dataSource={indexDataSource} columns={columns}/>
        </>
    )
}


